import styled from "styled-components/macro";
import { TalentsList } from "./TalentsList";

import { CategoryList } from "./CategoryList";

export function TalentsListPage() {
  return (
    <Container>
      <CategoryList />
      <TalentsList />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  min-height: 100%;
`;
